import { render } from "./FontAwesomeLibraryComponent.vue?vue&type=template&id=1dafe212"
import script from "./FontAwesomeLibraryComponent.vue?vue&type=script&lang=js"
export * from "./FontAwesomeLibraryComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__